import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Список
  list (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/report/list?${filter}`)
  },
  // список годов
  getRefYear (id) {
    return axios.get(`${i18n.locale}/api/limit/getRefYear/${id}`)
  },
  // список всех лимитов по ООПТ и году
  limitListByOoptYear (ooptId, yearId) {
    return axios.get(`${i18n.locale}/api/limit/limitListByOoptYear/${ooptId}/${yearId}`)
  },
  getLimitListByYear (yearId, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/limit/limitListByYear/${yearId}?${filter}`)
  },
  getFormData () {
    return axios.get(`${i18n.locale}/api/limit/formData`)
  },
  // список ООПТ в форме
  getOoptDataBySoateAndType (soateId, ooptTypeId) {
    let filter = ''
    if (ooptTypeId !== undefined) {
      filter = `ooptType=${ooptTypeId}`
    }
    return axios.get(`${i18n.locale}/api/limit/getOoptDataBySoateAndType/${soateId}?${filter}`)
  },
  // Получение данных для формы аннулирование квоты
  getLimitListByOoptYearWithQuota (id, yearId) {
    return axios.get(`${i18n.locale}/api/limit/limitListByOoptYearWithQuota/${id}/${yearId}`)
  }
}
